module.exports = __webpack_public_path__ + "img/square-x.19ce4026.svg";